import { useState } from 'react';
import { useTracking } from 'react-tracking';

import { useFlag } from '@simplywallst/unleash';
import { useUserAgent } from '@simplywallst/hooks/useUserAgent';

import { useIsMobileScreen } from '@/hooks/useMedia';
import { useTypeformDrawer } from '@/hooks/useTypeformDrawer';

import { Button } from '@simplywallst/ui-core/next';
import DownloadReportSolid from '@simplywallst/ui-core/icons/DownloadReportSolid';

import { InstructionsModal } from '../components/InstructionsModal';

type Props = {
  onImportClick: () => void;
};

export const Header = ({ onImportClick }: Props) => {
  const [showInstructionsModal, setShowInstructionsModal] = useState(false);

  const { isMobile } = useUserAgent();
  const isMobileScreen = useIsMobileScreen({ defaultMatches: isMobile });

  const popUpFeedbackForm = useTypeformDrawer('ayijp5kv');

  const { trackEvent } = useTracking();

  const showUploadTransactionsButton = useFlag('mono-upload-transactions');

  return (
    <header className="grid grid-rows-[max-content_max-content] gap-x2 p-x3 md:grid-cols-[max-content_1fr] md:grid-rows-[auto] md:items-center md:gap-x5 md:px-x5 md:py-7">
      <div className="flex items-center gap-x2">
        <h1 className="m-0 text-xl text-solid">
          <strong>Add your transactions</strong>
        </h1>
        {showUploadTransactionsButton.enabled && (
          <Button
            className="w-max"
            variant="secondary"
            onClick={() => {
              onImportClick();
              trackEvent({
                modifier: 'Import file',
                action: 'click',
              });
            }}
          >
            <DownloadReportSolid />
            <div className="text-nowrap text-solid">Import file</div>
          </Button>
        )}
      </div>
      <div className="grid grid-cols-[max-content_max-content] justify-between gap-x4 md:justify-end">
        <button
          className="grid grid-cols-[max-content] items-center"
          onClick={() => setShowInstructionsModal(true)}
        >
          <p className="m-0 text-xs text-soft">How to add my transactions?</p>
        </button>
        <button
          className="grid grid-cols-[max-content] items-center"
          onClick={popUpFeedbackForm}
        >
          <p className="m-0 text-xs text-soft">
            {isMobileScreen ? 'Feedback' : 'Give feedback'}
          </p>
        </button>
      </div>
      {showInstructionsModal && (
        <InstructionsModal onClose={() => setShowInstructionsModal(false)} />
      )}
    </header>
  );
};
